// Computes reading time from actual content instead of a hand-typed
// guess that drifts out of sync the moment the article text changes.
// Standard formula: strip markup, count words, divide by average adult
// reading speed (~225 wpm), round up to the nearest whole minute, floor of 1.
const WORDS_PER_MINUTE = 225;

export function calculateReadTime(html) {
  if (!html) return '1 min';
  const text = html
    .replace(/<[^>]+>/g, ' ')   // strip tags
    .replace(/&[a-z]+;/gi, ' ') // strip HTML entities (&nbsp; etc.)
    .trim();
  const wordCount = text ? text.split(/\s+/).length : 0;
  const minutes = Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));
  return `${minutes} min`;
}
